module.exports = __webpack_public_path__ + "static/video_slide_1-b1277c7732dda3c4681cc6811b393b63.ogv";